import * as winston from "winston";
import BrowserConsole from 'winston-transport-browserconsole';

// use debug in development and silent in production
const getLogLevel = (): string | undefined => {
    switch(sessionStorage.getItem("logLevel")) {
        case "0":
            return "error";
        case "1":
            return "warn";
        case "2":
            return "info";
        case "3":
            return "http";
        case "4":
            return "verbose";
        case "5":
            return "debug";
    }
    return "silent";
}

const options: winston.LoggerOptions = {
    transports: [
        new BrowserConsole(
            {
                format: winston.format.simple(),
                level: getLogLevel(),
            },
        )
    ],
}

export const logger = winston.createLogger(options)